import { __ } from '@wordpress/i18n';
import { render,createRoot } from '@wordpress/element';
import domReady from '@wordpress/dom-ready';
import store from '../vayu-sites/store.js';
import { Provider } from 'react-redux';
import VayuDesignLibraryButton from './appDesign.js'


domReady(() => {
	const tryInject = () => {
		const target = document.querySelector('.editor-document-tools');

		if (target && !document.getElementById('vayu-design-library-wrapper')) {
			const wrapper = document.createElement('div');
			wrapper.id = 'vayu-design-library-wrapper';
			target.appendChild(wrapper);

			// if (wrapper) {
			// const root = createRoot(wrapper);
			// root.render(
			// 	<Provider store={store}>
			// 		<VayuDesignLibraryButton/>
			// 	</Provider>
			// );
		//}


			render(
				<Provider store={store}>
					<VayuDesignLibraryButton />
				</Provider>,
				wrapper
			);
		}
	};
 setTimeout(() => {
	wp.data.subscribe(() => {
		tryInject();
	});

	 }, 50);

	
});
